export default __webpack_public_path__ + "static/media/default-freeflow.fd53a8a0.png";